/* clone-lp: behaviour of the healora landing sections (scroll to package, sliders, video modal,
   FAQ accordion, reviews toggle, science bars, timeline, countdowns). No dependencies. */
(function () {
  if (window.__cloneLp) return;
  window.__cloneLp = true;

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---- scroll to the package block ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-clp-scroll]');
    if (!a) return;
    var target = document.getElementById('clp-package') || document.querySelector('[data-clp-package]');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 10;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ---- sliders ---- */
  function initSlider(root) {
    if (root.__clp) return;
    root.__clp = true;
    var track = root.querySelector('[data-clp-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-clp-tab]'));
    function step() {
      var s = slides[0];
      if (!s) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return s.getBoundingClientRect().width + gap;
    }
    var picked = null; // tab chosen by click (the last tabs may not be reachable as first visible slide)
    function current() { return Math.round(track.scrollLeft / step()); }
    function mark() {
      var i = picked !== null ? picked : current();
      slides.forEach(function (s, k) { s.classList.toggle('swiper-slide-active', k === i); });
      tabs.forEach(function (t, k) { t.classList.toggle('swiper-slide-thumb-active', k === i); });
    }
    function go(i) {
      var max = slides.length - 1;
      if (i < 0) i = max;
      if (i > max) i = 0;
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    root.querySelectorAll('[data-clp-prev]').forEach(function (b) { b.addEventListener('click', function () { picked = null; go(current() - 1); }); });
    root.querySelectorAll('[data-clp-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        picked = null;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        go(atEnd ? 0 : current() + 1);
      });
    });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { picked = k; go(k); mark(); }); });
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, function () { picked = null; }, { passive: true });
    });
    var tm;
    track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(mark, 60); }, { passive: true });
    mark();
  }

  /* ---- UGC video modal ---- */
  function initVideos(root) {
    if (root.__clpv) return;
    root.__clpv = true;
    var modal = root.querySelector('.ugc-modal');
    if (!modal) return;
    var video = modal.querySelector('video');
    function close() {
      modal.classList.remove('active');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
    }
    root.querySelectorAll('[data-clp-video]').forEach(function (el) {
      el.addEventListener('click', function () {
        var src = el.getAttribute('data-clp-video');
        if (!src || !video) return;
        video.src = src;
        modal.classList.add('active');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.ugc-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- FAQ + reviews toggles ---- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.clp .faq-row .accordion');
    if (h) {
      var row = h.closest('.faq-row');
      var open = !row.classList.contains('is-open');
      row.parentElement.querySelectorAll('.faq-row.is-open').forEach(function (r) {
        r.classList.remove('is-open');
        var a = r.querySelector('.accordion');
        a.classList.remove('accordion-open'); a.classList.add('accordion-close'); a.setAttribute('aria-expanded', 'false');
      });
      if (open) {
        row.classList.add('is-open');
        h.classList.add('accordion-open'); h.classList.remove('accordion-close'); h.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    var m = e.target.closest('.clp .more-review');
    if (m) {
      e.preventDefault();
      var box = m.closest('.testimonial-box');
      if (box) box.classList.add('is-open');
    }
  });

  /* ---- science bars + counters, timeline ---- */
  function animateBars(root) {
    root.querySelectorAll('.result_box-row').forEach(function (row) {
      var w = parseInt(row.getAttribute('data-wdth'), 10) || 0;
      var bar = row.querySelector('.result_bar_inr');
      var num = row.querySelector('[data-clp-count]');
      if (bar) bar.style.width = w + '%';
      if (num) {
        var start = 10, t0 = null;
        var run = function (ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1500);
          num.textContent = Math.round(start + (w - start) * p);
          if (p < 1) requestAnimationFrame(run);
        };
        requestAnimationFrame(run);
      }
    });
  }
  function initScience(root) {
    if (root.__clps) return;
    root.__clps = true;
    if (!('IntersectionObserver' in window)) { animateBars(root); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { animateBars(root); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(root);
  }

  var timelines = [];
  function updateTimeline(mid) {
    var first = mid.querySelector('.timeline__entry_point');
    var rows = mid.querySelectorAll('.timeline__mid_row');
    if (!first || !rows.length) return;
    var last = rows[rows.length - 1];
    var top = first.getBoundingClientRect().top;
    var total = last.getBoundingClientRect().top - top;
    first.style.setProperty('--timeline-height', Math.max(0, total) + 'px');
    var trigger = window.innerHeight * 0.6;
    var progress = Math.min(total, Math.max(0, trigger - top - 60));
    first.style.setProperty('--timeline-height-dynamic', progress + 'px');
    rows.forEach(function (r) {
      var on = r.getBoundingClientRect().top < trigger;
      r.querySelectorAll('.timeline__row_center_step, .timeline__row_content_box').forEach(function (el) { el.classList.toggle('viewing', on); });
    });
  }
  window.addEventListener('scroll', function () { timelines.forEach(updateTimeline); }, { passive: true });
  window.addEventListener('resize', function () { timelines.forEach(updateTimeline); });

  /* ---- countdowns ---- */
  var KEY = 'clpCountdownEnd';
  function countdownEnd(minutes) {
    var now = Date.now();
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end || end <= now) {
      end = now + minutes * 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-clp-countdown]').forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-clp-countdown'), 10) || 240;
      var left = Math.max(0, countdownEnd(mins) - now);
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    });
    var d = new Date();
    var mid = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    var r = Math.floor((mid - d) / 1000);
    var within = Math.floor(r / 3600) + 'hr ' + Math.floor((r % 3600) / 60) + 'mins ' + (r % 60) + 'sec';
    var tomorrow = mid.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    document.querySelectorAll('[data-clp-ship-date]').forEach(function (el) { el.textContent = tomorrow; });
    document.querySelectorAll('[data-clp-ship-within]').forEach(function (el) { el.textContent = within; });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-clp-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-clp-videos]').forEach(initVideos);
    scope.querySelectorAll('[data-clp-science]').forEach(initScience);
    scope.querySelectorAll('[data-clp-timeline]').forEach(function (m) {
      if (timelines.indexOf(m) < 0) timelines.push(m);
      updateTimeline(m);
    });
    tick();
  }
  setInterval(tick, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    timelines = timelines.filter(function (m) { return document.contains(m); });
    init(e.target);
  });
})();
